(function ( $ ) {

   $.fn.searchInput = function( options ) {

       initialized = false;
       var xhr;

       this.keyup(function(event){
           if(event.keyCode){
               if (initialized){
                   xhr.abort()
               }
               initialized = true;
               xhr = $.ajax({
                   type: "GET",
                   url : "/api/v1/post?search="+this.value,
                   success: function(res){
                       initialized = false;

                       if (res.results.length) {
                           $.each(res.results, function(i){
                               var delay = i*100;
                               var that = this;
                               setTimeout(function(){
                                   $("#searchResults ul").append(
                                       $('<li><a href="' + that.url + '"><div class="result-item c-white text-left"><div class="media"><div class="media-left"><img class="" style="width: 70px; margin-right: 20px; border-radius: 3px;" src="' + that.thumbnail.circle + '" alt="' + that.title + '"></div><div class="media-body media-middle"><h2>' + that.title + '</h2><p>' + that.excerpt + '</p></div></div></div></a></li>').fadeIn())
                               }, delay)
                           })
                       } else {
                           $("#searchResults ul").append(
                           $('<li><div class="result-item c-white text-left"><h2 class="text-center ptl">Aucun article ne correspond à votre recherche</h2></li>').fadeIn())
                       }
                   }
               });
           };
       })
   }
}(jQuery));
